import { Link } from "react-router-dom";
import { trackTrailer } from "@/lib/trailerTracker";

const TRAILER_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/8hj3ckuz_copy_5EC9987C-0287-4D7B-AB31-1FC6B02F703E.mov";
const POSTER = "https://images.unsplash.com/photo-1758738180478-0fd260c86605?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdvbWFuJTIwcG9ydHJhaXQlMjBlbGVnYW50JTIwZ29sZHxlbnwwfHx8fDE3ODU2ODY4ODl8MA&ixlib=rb-4.1.0&q=85";

export default function TeaserSlot({
    source,
    eyebrow = "Original Series · First look",
    title = "Watch the trailer.",
    subtitle = "A cinematic first look at what we're building. The debut cast is being chosen now.",
    cta = "Watch on the series page",
}) {
    return (
        <section className="py-24 border-t border-[color:var(--espresso)] bg-[color:var(--warm-black)]" data-testid={`teaser-slot-${source}`}>
            <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5">
                    <p className="eyebrow">{eyebrow}</p>
                    <h2 className="font-display text-4xl md:text-6xl mt-4 leading-[0.95]">{title}</h2>
                    <p className="mt-6 text-[color:var(--cream-muted)] max-w-md">{subtitle}</p>
                    <div className="mt-8">
                        <Link
                            to="/original-series#trailer"
                            onClick={() => trackTrailer(source, "click")}
                            className="btn-gold btn-gold-solid"
                            data-testid={`teaser-cta-${source}`}
                        >
                            ▶ {cta}
                        </Link>
                    </div>
                </div>
                <div className="lg:col-span-7">
                    <div className="border border-[color:var(--gold)]/30 overflow-hidden bg-black">
                        <video
                            src={TRAILER_URL}
                            poster={POSTER}
                            controls
                            playsInline
                            preload="metadata"
                            onPlay={() => trackTrailer(source, "play")}
                            className="w-full h-auto max-h-[520px] object-contain bg-black"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
